export default __webpack_public_path__ + "static/media/bg.f7716262.png";